(function () {
  'use strict';

  const CONFIG = {
    minQty: 1,
    maxQty: 99,
    mobileBreakpoint: 749,
    priceBlockSelector: '.custom-price-inline',
    qtyInputSelectors: [
      'input[name="quantity"]',
      '.quantity__input',
      '[data-quantity-input]',
      'input[id*="Quantity"]',
      'input[id*="quantity"]',
    ],
  };

  const PILL_ID = 'qty-pill-mobile-inline';

  function injectCSS() {
    if (document.getElementById(PILL_ID + '-css')) return;
    const style = document.createElement('style');
    style.id = PILL_ID + '-css';
    style.textContent = `
      .qpm-row {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      .qpm-pill {
        display: inline-flex;
        align-items: center;
        border: 1.5px solid #d1d5db;
        border-radius: 30px;
        overflow: hidden;
        background: var(--grey-color);
        --input-bg: var(--color-white);
        height: 31px;
        flex-shrink: 0;
        user-select: none;
      }

      .qpm-btn {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--grey-color);
        color: #111;
        border: none;
        cursor: pointer;
        padding: 0;
        line-height: 1;
        transition: background 0.15s ease;
        -webkit-tap-highlight-color: transparent;
      }
      .qpm-btn:disabled { opacity: 0.35; cursor: not-allowed; }
      .qpm-count {
        min-width: 36px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 600;
        color: #111;
        background: var(--grey-color);
        padding: 0 6px;
        text-align: center;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);
  }

  function findEl(selectors) {
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function buildPill() {
    const pill = document.createElement('div');
    pill.className = 'qpm-pill';
    pill.id = PILL_ID;

    const dec = document.createElement('button');
    dec.type = 'button';
    dec.className = 'qpm-btn';
    dec.setAttribute('aria-label', 'Decrease quantity');
    dec.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 2" fill="none"><path d="M1 1H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`;

    const count = document.createElement('span');
    count.className = 'qpm-count';
    count.setAttribute('aria-live', 'polite');
    count.textContent = '1';

    const inc = document.createElement('button');
    inc.type = 'button';
    inc.className = 'qpm-btn';
    inc.setAttribute('aria-label', 'Increase quantity');
    inc.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 1V11M1 6H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`;

    pill.appendChild(dec);
    pill.appendChild(count);
    pill.appendChild(inc);

    return { pill, dec, inc, count };
  }

  function init() {
    /* Run on ALL screen sizes — CSS handles display:none above breakpoint */
    if (document.getElementById(PILL_ID)) return;

    const priceBlock = document.querySelector(CONFIG.priceBlockSelector);
    if (!priceBlock) return;

    const mainInput = findEl(CONFIG.qtyInputSelectors);

    injectCSS();

    const { pill, dec, inc, count } = buildPill();

    const parent = priceBlock.parentElement;
    if (!parent) return;

    const row = document.createElement('div');
    row.className = 'qpm-row';
    parent.insertBefore(row, priceBlock);
    row.appendChild(priceBlock);
    row.appendChild(pill);

    function getQty() { return parseInt(count.textContent, 10) || 1; }

    function setQty(val) {
      val = Math.max(CONFIG.minQty, Math.min(CONFIG.maxQty, val));
      count.textContent = val;
      dec.disabled = val <= CONFIG.minQty;
      inc.disabled  = val >= CONFIG.maxQty;
      if (mainInput) {
        mainInput.value = val;
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
        mainInput.dispatchEvent(new Event('input',  { bubbles: true }));
      }
    }

    const seed = mainInput ? parseInt(mainInput.value, 10) : 1;
    setQty(isNaN(seed) ? 1 : seed);

    dec.addEventListener('click', () => setQty(getQty() - 1));
    inc.addEventListener('click', () => setQty(getQty() + 1));

    if (mainInput) {
      mainInput.addEventListener('change', () => {
        setQty(parseInt(mainInput.value, 10) || 1);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
